export const formatAmount = (amount?: number): string => {
    if (amount == null) {
        return '-';
    }

    return amount.toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
